import React from 'react';
import { Col, Row } from 'components';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';
import { CityShippingRates } from 'feature/countryTabs/shipping/cityShippingRates';
import { ShippingRates } from 'feature/countryTabs/shipping/shippingRates';

export const CountryShipping = React.memo(() => {
  return (
    <Row className={'gap-40'}>
      <Col flex={'1'}>
        <HasAccess role={PERMISSIONS.countries.shipping_rate.read}>
          <ShippingRates />
        </HasAccess>
      </Col>
      <Col flex={'1'}>
        <HasAccess role={PERMISSIONS.countries.shipping_city_rate.read}>
          <CityShippingRates />
        </HasAccess>
      </Col>
    </Row>
  );
});
